<ngx-http-loader
  [customTemplate]="loaderTemplate"
  [filterHttpHeaders]="['ignore_http_loader']"
>
  <ng-template #loaderTemplate>
    <app-progress-bar></app-progress-bar>
  </ng-template>
</ngx-http-loader>

<app-progress-bar *ngIf="loadingRoute"></app-progress-bar>

<!--Page Styles-->
<router-outlet></router-outlet>

<p-toast position="top-center"></p-toast>
